/* ============
 * businessDays Module Mutations
 * ============
 */

import {
  FETCH_BUSINESS_DAYS,
} from './../../mutation-types';

export default {
  [FETCH_BUSINESS_DAYS](state, days) {
    state.all = days;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/businessDay/mutations.js